/** Page through a list held in memory: "11–20 of 57" and First / Previous / n / Next / Last. */
export function Pager({
  page,
  pageSize,
  total,
  onPage,
  className = "mt-3",
}: {
  /** Zero-based; clamp it with `clampPage` (lib/paging) first. */
  page: number;
  pageSize: number;
  total: number;
  onPage: (page: number) => void;
  className?: string;
}) {
  const pageCount = Math.max(1, Math.ceil(total / pageSize));
  if (pageCount <= 1) return null;
  const start = page * pageSize;
  return (
    <div className={`${className} flex items-center justify-between gap-3 text-xs text-[var(--text-muted)]`}>
      <span>
        {start + 1}–{Math.min(start + pageSize, total)} of {total.toLocaleString()}
      </span>
      <div className="flex items-center gap-1">
        <button type="button" className="btn btn-ghost btn-sm" disabled={page === 0} onClick={() => onPage(0)}>
          First
        </button>
        <button type="button" className="btn btn-ghost btn-sm" disabled={page === 0} onClick={() => onPage(page - 1)}>
          Previous
        </button>
        <span className="px-1 tabular-nums">
          {page + 1} / {pageCount}
        </span>
        <button
          type="button"
          className="btn btn-ghost btn-sm"
          disabled={page >= pageCount - 1}
          onClick={() => onPage(page + 1)}
        >
          Next
        </button>
        <button
          type="button"
          className="btn btn-ghost btn-sm"
          disabled={page >= pageCount - 1}
          onClick={() => onPage(pageCount - 1)}
        >
          Last
        </button>
      </div>
    </div>
  );
}
